import { defineMessages } from "react-intl";

export const MESSAGES = defineMessages({
  selectAnAdditionalPlatformError: {
    id: "funding-application: add additional platform error",
    defaultMessage: "Please select an additional platform",
  },
  addAnotherPlatformHeading: {
    id: "funding-application: add another platform heading",
    defaultMessage: "Add another account or platform",
  },
  selectAditionalPlatformDescription: {
    id: "funding-application: select additional platform description",
    defaultMessage: "Select an account or platform to add to your application.",
  },
  // platform categories
  onlineSalesPlatformCategory: {
    id: "funding-application: online sales platform category next",
    defaultMessage: "Online sales",
  },
  eCommercePlatformCategory: {
    id: "funding-application: ecommerce platform category next",
    defaultMessage: "eCommerce",
  },
  marketingAnalyticsPlatformCategory: {
    id: "funding-application: marketing analytics platform category next",
    defaultMessage: "Marketing and analytics",
  },
  marketingPlatformCategory: {
    id: "funding-application: marketing platform category next",
    defaultMessage: "Marketing",
  },
  accountingPlatformCategory: {
    id: "funding-application: accounting platform category next",
    defaultMessage: "Accounting",
  },
  accountingPlatformOtherSoftware: {
    id: "funding-application: accounting platform other software",
    defaultMessage: "Other software...",
  },
  paymentsPlatformCategory: {
    id: "funding-application: payments platform category next",
    defaultMessage: "Payments",
    description: "Title of a section listing payment platforms customers can connect",
  },
  bankingPlatformCategory: {
    id: "funding-application: banking platform category next",
    defaultMessage: "Banking",
    description: "Title of a section listing banking platforms customers can connect",
  },
  addNewBankPlatform: {
    id: "funding-application: add bank accoount title next",
    defaultMessage: "Add bank account",
    description: "Title of the option to add new bank platform to funding application",
  },
  addAnotherPlatformContinueButton: {
    id: "funding-application: add another platform button continue",
    defaultMessage: "Add platform",
    description: "Confirm button after customer has selected another platform to add",
  },
  addAnotherPlatformCancel: {
    id: "funding-application: add another platform button cancel",
    defaultMessage: "Cancel",
    description: "Cancel button if customer does not wish to add another platform",
  },
});
